import { AgmCoreModule } from '@agm/core';
import { AzcCoreModule, AzcMaterialModule } from 'ac-ui-core-local';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivityPaymentStatusDialogComponent } from './dialogs/activity-payment-status-dialog/activity-payment-status-dialog.component';
import { ActivityStatusDialogComponent } from './dialogs/activity-status-dialog/activity-status-dialog.component';
import { DeleteConfirmDialogComponent } from './dialogs/delete-confirm-dialog/delete-confirm-dialog.component';
import { AutocompleteSelectComponent } from './forms/autocomplete-select/autocomplete-select.component';
import { ChipOptionListComponent } from './forms/chip-option-list/chip-option-list.component';
import { InlineFieldComponent } from './forms/inline-field/inline-field.component';
import { LocationInputComponent } from './forms/location-input/location-input.component';
import { FilterMetaService } from './services/filter-meta.service';
import { FeedbackUpdateActionDialogComponent } from './dialogs/feedback-update-action-dialog/feedback-update-action-dialog.component';
import { MultiselectComponent } from './forms/multiselect/multiselect.component';
import { GiftcardEditDialogComponent } from './dialogs/giftcard-edit-dialog/giftcard-edit-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		AzcMaterialModule,
		AzcCoreModule,
		AgmCoreModule
	],
	declarations: [
		InlineFieldComponent,
		LocationInputComponent,
		ChipOptionListComponent,
		ActivityStatusDialogComponent,
		ActivityPaymentStatusDialogComponent,
		DeleteConfirmDialogComponent,
		AutocompleteSelectComponent,
		FeedbackUpdateActionDialogComponent,
		MultiselectComponent,
		GiftcardEditDialogComponent
	],
	entryComponents: [
		ActivityStatusDialogComponent,
		ActivityPaymentStatusDialogComponent,
		DeleteConfirmDialogComponent,
		FeedbackUpdateActionDialogComponent,
		MultiselectComponent,
		GiftcardEditDialogComponent
	],
	exports: [
		InlineFieldComponent,
		LocationInputComponent,
		ChipOptionListComponent,
		ActivityStatusDialogComponent,
		ActivityPaymentStatusDialogComponent,
		DeleteConfirmDialogComponent,
		AutocompleteSelectComponent,
		FeedbackUpdateActionDialogComponent,
		MultiselectComponent,
		GiftcardEditDialogComponent
	],
	providers: [FilterMetaService]
})
export class AzcCommonModule { }
